import React from "react"
import "./address.css"

export class Address extends React.Component {
	constructor (args) {
		super(args)
		this.state = {
			Error: {},
			values: {},
		}
	}
	render () {
		return (
			<div className="section__content">
				<div className="add__wrapper">
					<div className="add__section">
						<div className="add_content">
							<div className="add_head">REGISTERED ADDRESS :</div>
							<div className="add_subtext">
							   Winpe Development Forum <br />
							   Upper Ground Floor, 376, Block B, Patparganj Road, Nirman Vihar
<br/>East Delhi, Delhi - 110092
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default Address



// WEBPACK FOOTER //
// ./src/components/Address/index.js